import { dispatchCustomEvent } from "../../shared/helpers";

const dayReviewChannel = (function() {
  const connection = App.Cable.connection()

  const init = ({ userID, date }) => {
    let _userID, _date, loadContent

    return connection.subscriptions.create({ channel: "DayReviews::CalendarLinkChannel", date, user_id: userID }, {
      connected() {
        _userID = userID
        _date = date

        if (loadContent) {
          loadContent = ! this.send({ type: "reload", date, user_id: userID })
        }
      },

      disconnected() {
        loadContent = true
        emitDisconnectedEvent({ date: _date, userID: _userID })
      },

      received(data) {
        const { html, type } = data
        if (data.user_id == _userID && data.date == _date) {
          switch(type) {
            case "link_update":
              emitUpdatedEvent({ html, userID: _userID, date: _date })
              break
          }
        }
      }
    })
  }

  const emitUpdatedEvent = (args) => dispatchCustomEvent("day-reviews--calendar-link-update", document, args)
  const emitDisconnectedEvent = (args) => dispatchCustomEvent("day-reviews--calendar-disconnect", document, args)

  return {
    init: init
  }
})()

export default dayReviewChannel



// WEBPACK FOOTER //
// ./app/javascript/channels/day_reviews/day_review_channel.js